<template>
  <div>
    <span v-for="i in 5" :key="`star-quality-${i}`">
      <i class="fa fa-star text-dark me-0" v-if="i <= quality.stars"></i>
      <i class="fal fa-star text-dark me-0" v-if="i > quality.stars"></i>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    quality: {
      default() {
        return {}
      }
    }
  }
}
</script>